/**
 * A team crest.
 *
 * A real logo when the team has one. When it does not but the team has a colour,
 * a disc in that colour carrying its initials — enough to tell four houses apart
 * at a glance on a fixture list, and it gives way to the real artwork the moment
 * a logo is uploaded. With neither, nothing at all, rather than a broken image
 * or an empty gap.
 */
import { useState } from 'react';

/** "House Sovereign" -> "HS", "Bed Shop Dream Team" -> "BS". */
function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0]?.toUpperCase() ?? '')
    .join('');
}

export default function Crest({
  url,
  name,
  colour = null,
  large = false,
}: {
  url: string | null;
  name: string;
  colour?: string | null;
  large?: boolean;
}) {
  const [failed, setFailed] = useState(false);
  const className = large ? 'crest lg' : 'crest';

  if (url && !failed) {
    return (
      <img
        className={className}
        src={url}
        alt={`${name} crest`}
        loading="lazy"
        decoding="async"
        onError={() => setFailed(true)}
      />
    );
  }

  if (colour) {
    return (
      <span
        className={`${className} crest-swatch`}
        style={{ background: colour }}
        aria-hidden="true"
        title={name}
      >
        {initials(name)}
      </span>
    );
  }

  return null;
}
